/**
 * Fuul Brand Color Tokens
 *
 * These colors are defined in tailwind.config.ts and available via Tailwind classes.
 * This file serves as documentation and for programmatic access.
 */

export const brandColors = {
  'fuul-dark-blue': '#1E2C62',
  'fuul-green': '#1CC9B9',
  'fuul-blue': '#4C6EF5',
  'fuul-black': '#13101E',
  'fuul-dark-grey': '#1B1B1F',
  'fuul-medium-grey': '#6B7280',
  'fuul-light-grey': '#DEE0E1',
  'fuul-white': '#FFFFFF',
} as const;

export const primaryScale = {
  50: '#EBF5FF',
  100: '#D6EBFF',
  200: '#ADD6FF',
  300: '#85C1FF',
  400: '#5CACFF',
  500: '#4C6EF5', // Main primary
  600: '#3D58C4',
  700: '#2E4293',
  800: '#1F2C62',
  900: '#101631',
} as const;

export const secondaryScale = {
  50: '#F5F3FF',
  100: '#EDE9FE',
  200: '#DDD6FE',
  300: '#C4B5FD',
  400: '#A78BFA',
  500: '#8B5CF6', // Main secondary (purple)
  600: '#7C3AED',
  700: '#6D28D9',
  800: '#5B21B6',
  900: '#4C1D95',
} as const;

export const tertiaryScale = {
  50: '#F0FDFA',
  100: '#CCFBF1',
  200: '#99F6E4',
  300: '#5EEAD4',
  400: '#2DD4BF',
  500: '#1CC9B9', // Main tertiary (teal)
  600: '#0D9488',
  700: '#0F766E',
  800: '#115E59',
  900: '#134E4A',
} as const;

export const accentScale = {
  50: '#ECFDF5',
  100: '#D1FAE5',
  200: '#A7F3D0',
  300: '#6EE7B7',
  400: '#34D399',
  500: '#10B981', // Main accent (green)
  600: '#059669',
  700: '#047857',
  800: '#065F46',
  900: '#064E3B',
} as const;

export const grayScale = {
  50: '#F9FAFB',
  100: '#F3F4F6',
  200: '#E5E7EB',
  300: '#D1D5DB',
  400: '#9CA3AF',
  500: '#6B7280',
  600: '#4B5563',
  700: '#374151',
  800: '#1F2937',
  900: '#111827',
} as const;

export const semanticColors = {
  success: '#10B981',
  warning: '#F59E0B',
  error: '#EF4444',
  info: '#3B82F6',
} as const;
